import type { PendingInvite } from '@danda/shared';
import type { OfflineNotification, LobbyState } from './lobbyStore.types';

export const notificationsSlice: Pick<
  LobbyState,
  | 'notifications'
  | 'pendingInvites'
  | 'addNotification'
  | 'markNotificationRead'
  | 'clearNotifications'
  | 'addPendingInvite'
  | 'removePendingInvite'
  | 'clearPendingInvites'
> = {
  notifications: [],
  pendingInvites: [],

  addNotification: (notification: OfflineNotification) => (state: LobbyState) => ({
    notifications: [notification, ...state.notifications],
  }),

  markNotificationRead: (id: string) => (state: LobbyState) => ({
    notifications: state.notifications.map((n: OfflineNotification) =>
      n.id === id ? { ...n, isRead: true } : n
    ),
  }),

  clearNotifications: () => ({ notifications: [] }),

  addPendingInvite: (invite: PendingInvite) => (state: LobbyState) => ({
    pendingInvites: [...state.pendingInvites, invite],
  }),

  removePendingInvite: (id: string) => (state: LobbyState) => ({
    pendingInvites: state.pendingInvites.filter((i: PendingInvite) => i.id !== id),
  }),

  clearPendingInvites: () => ({ pendingInvites: [] }),
};
